import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { WhiteLabelAplicavelResponse, WhiteLabelRequest, WhiteLabelResponse } from "app/shared/models/ei-models";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { BaseService } from "../../core";

@Injectable({ providedIn: 'root' })
export class WhiteLabelService extends BaseService {
    private endpoint = environment.urlEdducaImobApi.concat('EdducaImobCore/WhiteLabel/');

    constructor(private http: HttpClient) {
        super();
    }

    /** Pré-login: identifica o WL pelo slug do subdomínio (público, sem auth). */
    obterPorSlug(slug: string): Observable<WhiteLabelAplicavelResponse> {
        return this.http.get<WhiteLabelAplicavelResponse>(
            this.endpoint.concat('PorSlug/', encodeURIComponent(slug)),
            { headers: this.getHeader(false) }
        );
    }

    /** Pós-login: WL aplicável ao usuário logado seguindo a hierarquia. */
    obterAplicavel(): Observable<WhiteLabelAplicavelResponse | null> {
        return this.http.get<WhiteLabelAplicavelResponse | null>(
            this.endpoint.concat('Aplicavel'),
            { headers: this.getHeader(false) }
        );
    }

    // ===== Admin =====

    listarTodos(): Observable<WhiteLabelResponse[]> {
        return this.http.get<WhiteLabelResponse[]>(
            this.endpoint.concat('ListarTodos'),
            { headers: this.getHeader(true) }
        );
    }

    obterPorId(id: number): Observable<WhiteLabelResponse> {
        return this.http.get<WhiteLabelResponse>(
            this.endpoint.concat('Obter/', id.toString()),
            { headers: this.getHeader(true) }
        );
    }

    obterPorOwner(tipoOwner: number, ownerId: number): Observable<WhiteLabelResponse | null> {
        return this.http.get<WhiteLabelResponse | null>(
            this.endpoint.concat(`PorOwner?tipoOwner=${tipoOwner}&ownerId=${ownerId}`),
            { headers: this.getHeader(false) }
        );
    }

    cadastrar(payload: WhiteLabelRequest): Observable<WhiteLabelResponse> {
        return this.http.post<WhiteLabelResponse>(
            this.endpoint.concat('Cadastrar'),
            payload,
            { headers: this.getHeader(true) }
        );
    }

    atualizar(id: number, payload: WhiteLabelRequest): Observable<WhiteLabelResponse> {
        return this.http.put<WhiteLabelResponse>(
            this.endpoint.concat('Atualizar/', id.toString()),
            payload,
            { headers: this.getHeader(true) }
        );
    }

    toggle(id: number): Observable<WhiteLabelResponse> {
        return this.http.patch<WhiteLabelResponse>(
            this.endpoint.concat('Toggle/', id.toString()),
            null,
            { headers: this.getHeader(true) }
        );
    }

    remover(id: number): Observable<void> {
        return this.http.delete<void>(
            this.endpoint.concat('Remover/', id.toString()),
            { headers: this.getHeader(true) }
        );
    }
}
